export default {"src":"/_next/static/image/public/imgs/es/favicon-dark.ac49da29145f7c50b7331454b652bfb0.ico","height":251,"width":256};